import styled, { css } from 'styled-components'
import { ReactComponent as ChevronVertical } from 'icons/chevron-vertical-16.svg'
import { ReactComponent as ResetIcon } from 'icons/anti-clockwise-arrow-circle-16.svg'
import { SelectPopover } from 'components/Select'
import Checkbox from 'components/Checkbox'
import Navbar from 'components/Navbar'
import Dropdown from 'components/Dropdown'

export const ToggleWrapper = styled.div(
  ({ theme: { colors, fontSizes, radii } }) => css`
    width: 88px;
    height: 30px;
    padding: 10px; /* stylelint-disable-line scales/space */
    margin: 1px; /* stylelint-disable-line scales/space */

    display: flex;
    justify-content: space-between;
    align-items: center;

    color: ${colors.foreground.secondary[3]};
    font-size: ${fontSizes.smaller};
    cursor: pointer;

    :hover,
    :focus {
      border-top-right-radius: ${radii.medium};
      border-bottom-right-radius: ${radii.medium};
      background-color: ${colors.state.hover};
      transition: background-color 0.3s ease-out;

      & svg {
        transition: color 0.3s ease-out;
        color: ${colors.foreground.secondary[1]};
      }
    }
  `
)

export const IconWrapper = styled.div(
  ({ theme: { colors } }) => css`
    display: flex;
    color: ${colors.foreground.secondary[4]};
    margin: 8px 0;
  `
)

export const StyledChevron = styled(ChevronVertical)`
  width: 12px;
  height: 12px;
`

export const StyledSelectPopover = styled(SelectPopover)`
  width: 270px;
`

export const StyledCheckbox = styled(Checkbox)`
  cursor: pointer;
`

export const StyledDropdownItem = styled(Dropdown.Item)`
  padding: 8px 12px 8px 12px;
`

export const StyledDropdownResetItem = styled(Dropdown.Item)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 12px 8px 12px;
`

interface StyledResetIconProps {
  disabled: boolean
}

export const StyledResetIcon = styled(ResetIcon)<StyledResetIconProps>`
  ${({ disabled }) => css`
    margin: 0 8px 2px 0; /* stylelint-disable-line scales/space */

    width: 12px;
    height: 16px;

    opacity: ${disabled ? 0.5 : 1};
  `}
`

export const Filter = styled(Navbar.Filter)`
  input[type='text'] {
    /* Padding right includes the clear button and the options button */
    padding-right: 120px; /* stylelint-disable-line scales/space */
  }
`

export const TooltipShortcut = styled.div(
  ({ theme }) => css`
    color: ${theme.colors.foreground.primary[2]};
  `
)
